import React, { useState, useEffect } from "react";
import logo from "../Image/logo.png";
import {
  AppstoreOutlined,
  CustomerServiceOutlined,
  UserOutlined,
  DollarOutlined,
  LogoutOutlined,
  MenuOutlined,
  CloseOutlined,
  RightOutlined,
} from "@ant-design/icons";
import { generateClient } from "aws-amplify/api";
import { signOut } from "@aws-amplify/auth";
import { Avatar, Button, Layout, Menu, theme, Drawer } from "antd";
import { Link } from "react-router-dom"; // Import Link
import { Outlet, useLocation } from "react-router-dom";
import { getUser } from "../graphql/queries";
import { getTableID } from "../Services/authServices";
import "./DefaultLayout.css";

const { Header, Content, Sider } = Layout;
const client = generateClient();

const DefaultLayout = () => {
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const item2 = [
    {
      key: "1",
      icon: React.createElement(AppstoreOutlined),
      label: "Dashboard",
      path: "/dashboard",
    },
    {
      key: "2",
      icon: React.createElement(UserOutlined),
      label: "Recipients",
      path: "/recipients",
    },
    {
      key: "3",
      icon: React.createElement(DollarOutlined),
      label: "Transactions",
      path: "/transactions",
    },
    {
      key: "4",
      icon: React.createElement(CustomerServiceOutlined),
      label: "Support",
      path: "/supportTicket",
    },
  ];
  const getSelectedKeys = () => {
    const path = location.pathname;
    if (path.startsWith("/myaccount")) return ["myaccount"];
    const match = item2.find((item) => path.startsWith(item.path));
    return match ? [match.key] : [];
  };

  const selectedKeys = getSelectedKeys();
  const [viewportWidth, setScreenWidth] = useState(window.innerWidth);
  const isMobile = viewportWidth < 768;

  const [screenHeight, setScreenHeight] = useState(window.innerHeight);
  const headerHeight = 90;
  const {
    token: { colorBgContainer },
  } = theme.useToken();
  const [fullName, setFullName] = useState("Loading...");
  const displayName = (fullName || "User").trim() || "User";
  const profileInitials =
    displayName
      .split(" ")
      .filter(Boolean)
      .slice(0, 2)
      .map((part) => part[0]?.toUpperCase() || "")
      .join("") || "U";
  const handleLogout = async () => {
    try {
      const response = await signOut();
      console.log("signout response ", response);
      localStorage.removeItem("loginTimestamp");
      localStorage.removeItem("dashboardVerificationPromptShouldShow");
      window.location.reload();
    } catch (error) {
      console.log("error signing out: ", error);
    }
  };

  useEffect(() => {
    const handleResize = () => {
      setScreenHeight(window.innerHeight);
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const fetchFullName = async () => {
      try {
        const tableID = await getTableID();

        if (tableID) {
          const { data } = await client.graphql({
            query: getUser,
            variables: { id: tableID },
          });
          const user = data?.getUser;
          const displayName = String(
            user?.businessName || user?.name || "",
          ).trim();
          if (displayName) {
            setFullName(displayName);
            return;
          }
        }

        throw new Error("No Table ID");
      } catch (error) {
        console.error("Error fetching header display name:", error);
        setFullName("User");
      }
    };
    fetchFullName();
  }, []);

  const mobileMenuItems = [
    ...item2.map((item) => ({
      key: item.key,
      icon: item.icon,
      label: (
        <Link to={item.path} onClick={() => setMobileMenuOpen(false)}>
          {item.label}
        </Link>
      ),
    })),
    {
      key: "logout",
      icon: React.createElement(LogoutOutlined),
      label: (
        <span
          onClick={() => {
            setMobileMenuOpen(false);
            handleLogout();
          }}
        >
          Logout
        </span>
      ),
    },
  ];

  return (
    <Layout className="defaultLayoutRoot">
      {!isMobile && (
        <Sider breakpoint="md" collapsedWidth="50" className="appSider">
          <div className="demo-logo-vertical appSiderInner">
            <Link to="/dashboard" style={{ display: "block" }}>
              <img src={logo} alt="image" className="appSidebarLogo" />
            </Link>
            <Menu
              mode="inline"
              selectedKeys={selectedKeys}
              className="appSidebarMenu"
            >
              {item2.map((item) => (
                <Menu.Item key={item.key} icon={item.icon}>
                  <Link to={item.path}>{item.label}</Link>
                </Menu.Item>
              ))}
            </Menu>
            <div className="appSidebarFooter">
              <Button
                type="text"
                icon={<LogoutOutlined />}
                className="appSidebarLogoutBtn"
                onClick={handleLogout}
                block
              >
                Logout
              </Button>
            </div>
          </div>
        </Sider>
      )}
      <Layout>
        <Header className="appHeader" style={{ background: colorBgContainer }}>
          {isMobile ? (
            <Link
              to="/dashboard"
              className="mobileHeaderLogoLink"
              onClick={() => setMobileMenuOpen(false)}
            >
              <img src={logo} alt="image" className="mobileHeaderLogo" />
            </Link>
          ) : (
            <div></div>
          )}

          <div
            style={{
              height: "100%",
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              gap: "2rem",
            }}
          >
            {isMobile ? (
              <Button
                type="text"
                icon={
                  <MenuOutlined
                    style={{ fontSize: "24px", color: "#325FD5" }}
                  />
                }
                onClick={() => setMobileMenuOpen(true)}
                style={{ padding: "4px 8px" }}
              />
            ) : (
              <Link to="/myaccount" className="appHeaderProfile">
                <span className="appHeaderGreeting">Hi, {displayName}</span>
                <Avatar size={36} className="appHeaderAvatar">
                  {profileInitials}
                </Avatar>
              </Link>
            )}
          </div>
        </Header>

        {isMobile && (
          <Drawer
            placement="top"
            onClose={() => setMobileMenuOpen(false)}
            open={mobileMenuOpen}
            height="auto"
            contentWrapperStyle={{ maxHeight: "85vh", height: "auto" }}
            rootClassName="mobileMenuDrawer"
            closable={false}
            styles={{ body: { padding: 0 } }}
            headerStyle={{
              padding: "8px 16px",
              borderBottom: "1px solid #e9edf6",
              background: colorBgContainer,
              minHeight: 56,
            }}
            title={
              <div className="drawerHeader">
                <Link
                  to="/dashboard"
                  className="mobileHeaderLogoLink"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  <img src={logo} alt="BajCan" className="mobileHeaderLogo" />
                </Link>
                <Button
                  type="text"
                  icon={
                    <CloseOutlined
                      style={{ fontSize: "24px", color: "#325FD5" }}
                    />
                  }
                  onClick={() => setMobileMenuOpen(false)}
                  className="drawerCloseBtn"
                />
              </div>
            }
          >
            <div className="mobileMenuProfile">
              <Link
                to="/myaccount"
                className="appHeaderProfile mobileMenuProfileLink"
                onClick={() => setMobileMenuOpen(false)}
              >
                <Avatar size={48} className="appHeaderAvatar">
                  {profileInitials}
                </Avatar>
                <span className="appHeaderGreeting">Hi, {displayName}</span>
                <RightOutlined className="mobileMenuProfileArrow" />
              </Link>
            </div>
            <Menu
              mode="inline"
              selectedKeys={selectedKeys}
              items={mobileMenuItems}
              style={{ fontSize: "16px", border: "none" }}
            />
          </Drawer>
        )}

        <Content style={{ margin: isMobile ? "16px 8px 0" : "24px 16px 0" }}>
          <div
            style={{
              padding: isMobile ? "12px 8px" : 24,
              minHeight: screenHeight - headerHeight,
            }}
          >
            <Outlet />
          </div>
        </Content>
      </Layout>
    </Layout>
  );
};

export default DefaultLayout;
